import { createContext, useContext } from "react";

import { AlertTypeEnum } from "@/constants";

import { AlertResultProps } from "./AlertResult";

interface AlertContextProps {
  alertType: AlertTypeEnum;
  loading: boolean;
  isEdit: boolean;
  open: boolean;
  openResult: boolean;
  editId?: string;
  alertModalInfo?: AlertResultProps["data"];
  infiniteMode: boolean;
  setInfiniteMode: (v: boolean) => void;
  setLoading: (v: boolean) => void;
  setOpen: (v: boolean) => void;
  setOpenResult: (v: boolean) => void;
  setAlertModalInfo: (v: AlertResultProps["data"]) => void;
}

const AlertContext = createContext<AlertContextProps>({});

export const useAlertContext = () => useContext(AlertContext);

export const AlertContextProvider = AlertContext.Provider;

export default AlertContext;
